
import React from 'react';
import { Plus } from 'lucide-react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import TaskList from './TaskList';
import TaskEmpty from './TaskEmpty';
import TaskLoading from './TaskLoading';
import AddTaskDialog from '../../business/quick-actions/AddTaskDialog';
import { useTaskPanel } from './useTaskPanel';

interface TaskPanelProps {
  leadId: string;
}

const TaskPanel: React.FC<TaskPanelProps> = ({ leadId }) => {
  const {
    isLoading,
    tasks,
    pendingTasks,
    completedTasks,
    isTaskDialogOpen,
    setIsTaskDialogOpen,
    newTaskTitle,
    setNewTaskTitle,
    newTaskDescription,
    setNewTaskDescription,
    newTaskDueDate,
    setNewTaskDueDate,
    newTaskPriority,
    setNewTaskPriority,
    newTaskAssignedTo,
    setNewTaskAssignedTo,
    newTaskCategories,
    setNewTaskCategories,
    newTaskReminderTimes,
    setNewTaskReminderTimes,
    handleAddTask,
    handleCompleteTask,
    handleDeleteTask,
    handleUpdateTask,
    priorityOptions,
  } = useTaskPanel(leadId);

  if (isLoading) {
    return <TaskLoading />;
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <div>
          <CardTitle>Tasks</CardTitle>
        </div>
        <Button onClick={() => setIsTaskDialogOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Add Task
        </Button>
      </CardHeader>
      <CardContent>
        {tasks.length === 0 ? (
          <TaskEmpty onAddTask={() => setIsTaskDialogOpen(true)} />
        ) : (
          <TaskList
            pendingTasks={pendingTasks}
            completedTasks={completedTasks}
            onCompleteTask={handleCompleteTask}
            onDeleteTask={handleDeleteTask}
            onUpdateTask={handleUpdateTask}
          />
        )}
      </CardContent>

      <AddTaskDialog
        isOpen={isTaskDialogOpen}
        setIsOpen={setIsTaskDialogOpen}
        newTaskTitle={newTaskTitle}
        setNewTaskTitle={setNewTaskTitle}
        newTaskDescription={newTaskDescription}
        setNewTaskDescription={setNewTaskDescription}
        newTaskDueDate={newTaskDueDate}
        setNewTaskDueDate={setNewTaskDueDate}
        newTaskPriority={newTaskPriority}
        setNewTaskPriority={setNewTaskPriority}
        newTaskAssignedTo={newTaskAssignedTo}
        setNewTaskAssignedTo={setNewTaskAssignedTo}
        newTaskCategories={newTaskCategories}
        setNewTaskCategories={setNewTaskCategories}
        newTaskReminderTimes={newTaskReminderTimes}
        setNewTaskReminderTimes={setNewTaskReminderTimes}
        handleAddTask={handleAddTask}
        priorityOptions={priorityOptions}
      />
    </Card>
  );
};

export default TaskPanel;
